window.add_property = function add_property(){
var box_properties = document.getElementById('box_properties');
var count = document.getElementsByClassName('count').length +1

//crear header
var div_header = document.createElement('div');
div_header.classList.add('count', 'card-header', 'bg-rent', 'text-light', 'pt-md-4', 'pb-md-4', 'subhead1', 'mt-3');
div_header.setAttribute('id','header_'+count);
div_header.innerHTML = 'Propiedad ' + count;

var link_arrow = document.createElement('a');
link_arrow.setAttribute('data-toggle','collapse');
link_arrow.setAttribute('href','#collapse_property_'+count);
link_arrow.setAttribute('role','button');
link_arrow.setAttribute('aria-expanded','false');
link_arrow.setAttribute('aria-controls','collapse_property_'+count);
link_arrow.classList.add('float-right');

var icon_arrow = document.createElement('i');
icon_arrow.classList.add('text-light', 'fas', 'fa-angle-up', 'fa-2x') 

link_arrow.appendChild(icon_arrow);
div_header.appendChild(link_arrow);
box_properties.appendChild(div_header);
//crear header

//span error
var span = document.createElement('span');
span.innerHTML="*";
span.classList.add('error')
//span error


//box collapse
var div_collapse = document.createElement('div');
div_collapse.setAttribute('id','collapse_property_'+count);
div_collapse.classList.add('collapse','bg-white', 'show');

var row = document.createElement('div');
row.classList.add('row','pl-5','pr-5','pt-5');


//input tipo
var box_input_tipo = document.createElement('div');
box_input_tipo.classList.add('form-group','col-md-6','col-12');

var label_tipo = document.createElement('label');
label_tipo.innerHTML="Tipo";
label_tipo.classList.add('rent-label');

var select_tipo = document.createElement('select');
select_tipo.setAttribute('name', 'lead_investor_insurance_insurance_request[properties_attributes]['+count+'][property_type]');
select_tipo.classList.add('form-control','select-custom'); 

var option_house = document.createElement('option');
option_house.setAttribute('value', 'house');
option_house.innerHTML="Casa";

var option_apartment = document.createElement('option');
option_apartment.setAttribute('value', 'apartment');
option_apartment.innerHTML="Departamento";

var option_office = document.createElement('option');
option_office.setAttribute('value', 'office');
option_office.innerHTML="Oficina";

select_tipo.appendChild(option_house);
select_tipo.appendChild(option_apartment);
select_tipo.appendChild(option_office);

box_input_tipo.appendChild(label_tipo);
box_input_tipo.appendChild(span);
box_input_tipo.appendChild(select_tipo);
row.appendChild(box_input_tipo);
//input tipo

//input direccion
var box_input_direccion = document.createElement('div');
box_input_direccion.classList.add('form-group','col-md-6','col-12');

var label_direccion = document.createElement('label');
label_direccion.innerHTML="Dirección propiedad";
label_direccion.classList.add('rent-label')

var input_direccion = document.createElement('input');
input_direccion.classList.add('form-control', 'input-custom');
input_direccion.setAttribute('placeholder','Dirección de domicilio');
input_direccion.setAttribute('name','lead_investor_insurance_insurance_request[properties_attributes]['+count+'][address]');

box_input_direccion.appendChild(label_direccion);
box_input_direccion.appendChild(span);
box_input_direccion.appendChild(input_direccion);
row.appendChild(box_input_direccion);
//input direccion

//input number
var box_input_number = document.createElement('div');
box_input_number.classList.add('form-group','col-md-6','col-12');

var label_number = document.createElement('label');
label_number.innerHTML="Número depto.";
label_number.classList.add('rent-label');

var input_number = document.createElement('input');
input_number.classList.add('form-control', 'input-custom');
input_number.setAttribute('placeholder','Número');
input_number.setAttribute('name','lead_investor_insurance_insurance_request[properties_attributes]['+count+'][apartment]');

box_input_number.appendChild(label_number);
box_input_number.appendChild(span);
box_input_number.appendChild(input_number);
row.appendChild(box_input_number);
//input number

//input comuna
var box_input_comuna = document.createElement('div');
box_input_comuna.classList.add('form-group','col-md-6','col-12');

var label_comuna = document.createElement('label');
label_comuna.innerHTML="Comuna";
label_comuna.classList.add('rent-label');

var select_comuna = document.createElement('select');
select_comuna.setAttribute('name', 'lead_investor_insurance_insurance_request[properties_attributes]['+count+'][commune]');
select_comuna.classList.add('form-control','select-custom'); 

box_input_comuna.appendChild(label_comuna);
box_input_comuna.appendChild(span);
box_input_comuna.appendChild(select_comuna);
row.appendChild(box_input_comuna);
//input comuna


//input region
var box_input_region = document.createElement('div');
box_input_region.classList.add('form-group','col-md-6','col-12');

var label_region = document.createElement('label');
label_region.innerHTML="Región";
label_region.classList.add('rent-label');

var select_region = document.createElement('select');
select_region.setAttribute('name', 'lead_investor_insurance_insurance_request[properties_attributes]['+count+'][region]');
select_region.classList.add('form-control','select-custom'); 

box_input_region.appendChild(label_region);
box_input_region.appendChild(span);
box_input_region.appendChild(select_region);
row.appendChild(box_input_region);
//input region


//input bodega
var box_input_bodegas = document.createElement('div');
box_input_bodegas.classList.add('form-group','col-md-6','col-12');

var label_bodegas = document.createElement('label');
label_bodegas.innerHTML="¿Tiene bodega?";
label_bodegas.classList.add('rent-label');

var select_bodegas = document.createElement('select');
select_bodegas.setAttribute('name', 'lead_investor_insurance_insurance_request[properties_attributes]['+count+'][warehouse]');
select_bodegas.classList.add('form-control','select-custom');

var option_no_bodegas = document.createElement('option');
option_no_bodegas.setAttribute('value', '0');
option_no_bodegas.innerHTML="No";

var option_si_bodegas = document.createElement('option');
option_si_bodegas.setAttribute('value', '1');
option_si_bodegas.innerHTML="Si";

select_bodegas.appendChild(option_no_bodegas);
select_bodegas.appendChild(option_si_bodegas);

box_input_bodegas.appendChild(label_bodegas);
box_input_bodegas.appendChild(span);
box_input_bodegas.appendChild(select_bodegas);
row.appendChild(box_input_bodegas);
//input bodega


//input estacionamiento
var box_input_estecionamiento = document.createElement('div');
box_input_estecionamiento.classList.add('form-group','col-md-6','col-12');

var label_estecionamiento = document.createElement('label');
label_estecionamiento.innerHTML="¿Tiene estacionamiento?";
label_estecionamiento.classList.add('rent-label');

var select_estecionamiento = document.createElement('select');
select_estecionamiento.setAttribute('name', 'lead_investor_insurance_insurance_request[properties_attributes]['+count+'][parking]');
select_estecionamiento.classList.add('form-control','select-custom');

var option_no_estecionamiento = document.createElement('option');
option_no_estecionamiento.setAttribute('value', '0');
option_no_estecionamiento.innerHTML="No";

var option_si_estecionamiento = document.createElement('option');
option_si_estecionamiento.setAttribute('value', '1');
option_si_estecionamiento.innerHTML="Si";

select_estecionamiento.appendChild(option_no_estecionamiento);
select_estecionamiento.appendChild(option_si_estecionamiento);

box_input_estecionamiento.appendChild(label_estecionamiento);
box_input_estecionamiento.appendChild(span);
box_input_estecionamiento.appendChild(select_estecionamiento);
row.appendChild(box_input_estecionamiento);
//input estacionamiento

//input hab
var box_input_hab = document.createElement('div');
box_input_hab.classList.add('form-group','col-md-6','col-12');

var label_hab = document.createElement('label');
label_hab.innerHTML="¿Tiene habitaciones?";
label_hab.classList.add('rent-label');

var select_hab = document.createElement('select');
select_hab.setAttribute('name', 'lead_investor_insurance_insurance_request[properties_attributes]['+count+'][rooms]');
select_hab.classList.add('form-control','select-custom');

var option_1 = document.createElement('option');
option_1.setAttribute('value', '1');
option_1.innerHTML="1";

var option_2 = document.createElement('option');
option_2.setAttribute('value', '2');
option_2.innerHTML="2";

var option_3 = document.createElement('option');
option_3.setAttribute('value', '3');
option_3.innerHTML="3";

var option_4 = document.createElement('option');
option_4.setAttribute('value', '4');
option_4.innerHTML="4";

var option_5 = document.createElement('option');
option_5.setAttribute('value', '5');
option_5.innerHTML="5";

var option_6 = document.createElement('option');
option_6.setAttribute('value', '6');
option_6.innerHTML="6";

var option_7 = document.createElement('option');
option_7.setAttribute('value', '7');
option_7.innerHTML="7";

var option_8 = document.createElement('option');
option_8.setAttribute('value', '8');
option_8.innerHTML="8";

var option_9 = document.createElement('option');
option_9.setAttribute('value', '9');
option_9.innerHTML="9";

var option_10 = document.createElement('option');
option_10.setAttribute('value', '10');
option_10.innerHTML="10";

select_hab.appendChild(option_1);
select_hab.appendChild(option_2);
select_hab.appendChild(option_3);
select_hab.appendChild(option_4);
select_hab.appendChild(option_5);
select_hab.appendChild(option_6);
select_hab.appendChild(option_7);
select_hab.appendChild(option_8);
select_hab.appendChild(option_9);
select_hab.appendChild(option_10);

box_input_hab.appendChild(label_hab);
box_input_hab.appendChild(span);
box_input_hab.appendChild(select_hab);
row.appendChild(box_input_hab);
//input hab

//input banos
var box_input_banos = document.createElement('div');
box_input_banos.classList.add('form-group','col-md-6','col-12');

var label_banos = document.createElement('label');
label_banos.innerHTML="¿Tiene baños?";
label_banos.classList.add('rent-label');

var select_banos = document.createElement('select');
select_banos.setAttribute('name', 'lead_investor_insurance_insurance_request[properties_attributes]['+count+'][bathrooms]');
select_banos.classList.add('form-control','select-custom');

var option_1 = document.createElement('option');
option_1.setAttribute('value', '1');
option_1.innerHTML="1";

var option_2 = document.createElement('option');
option_2.setAttribute('value', '2');
option_2.innerHTML="2";

var option_3 = document.createElement('option');
option_3.setAttribute('value', '3');
option_3.innerHTML="3";

var option_4 = document.createElement('option');
option_4.setAttribute('value', '4');
option_4.innerHTML="4";

var option_5 = document.createElement('option');
option_5.setAttribute('value', '5');
option_5.innerHTML="5";

var option_6 = document.createElement('option');
option_6.setAttribute('value', '6');
option_6.innerHTML="6";

var option_7 = document.createElement('option');
option_7.setAttribute('value', '7');
option_7.innerHTML="7";

var option_8 = document.createElement('option');
option_8.setAttribute('value', '8');
option_8.innerHTML="8";

var option_9 = document.createElement('option');
option_9.setAttribute('value', '9');
option_9.innerHTML="9";

var option_10 = document.createElement('option');
option_10.setAttribute('value', '10');
option_10.innerHTML="10";

select_banos.appendChild(option_1);
select_banos.appendChild(option_2);
select_banos.appendChild(option_3);
select_banos.appendChild(option_4);
select_banos.appendChild(option_5);
select_banos.appendChild(option_6);
select_banos.appendChild(option_7);
select_banos.appendChild(option_8);
select_banos.appendChild(option_9);
select_banos.appendChild(option_10);

box_input_banos.appendChild(label_banos);
box_input_banos.appendChild(span);
box_input_banos.appendChild(select_banos);
row.appendChild(box_input_banos);
//input hab

//input total
var box_input_total = document.createElement('div');
box_input_total.classList.add('form-group','col-md-6','col-12');

var label_total = document.createElement('label');
label_total.innerHTML="Superficie total";
label_total.classList.add('rent-label');

var input_total = document.createElement('input');
input_total.classList.add('form-control', 'input-custom');
input_total.setAttribute('placeholder','Ingresa mt2');
input_total.setAttribute('name','lead_investor_insurance_insurance_request[properties_attributes]['+count+'][total_area]');

box_input_total.appendChild(label_total);
box_input_total.appendChild(span);
box_input_total.appendChild(input_total);
row.appendChild(box_input_total);
//input total

//input util
var box_input_total = document.createElement('div');
box_input_total.classList.add('form-group','col-md-6','col-12');

var label_total = document.createElement('label');
label_total.innerHTML="Superficie útil";
label_total.classList.add('rent-label');

var input_total = document.createElement('input');
input_total.classList.add('form-control', 'input-custom');
input_total.setAttribute('placeholder','Ingresa mt2');
input_total.setAttribute('name','lead_investor_insurance_insurance_request[properties_attributes]['+count+'][living_area]');

box_input_total.appendChild(label_total);
box_input_total.appendChild(span);
box_input_total.appendChild(input_total);
row.appendChild(box_input_total);
//input util

//input delete
var box_input_delete = document.createElement('div');
box_input_delete.classList.add('form-group','col-md-6','col-12', 'pb-5', 'text-center', 'pt-5');

var i = document.createElement('i');
i.classList.add('fas', 'fa-trash-alt', 'error', 'd-inline', 'pr-3');

var p = document.createElement('p');
p.classList.add('error','bold', 'd-inline', 'pointer');
p.setAttribute('id',count);
p.setAttribute('onclick', 'delete_property(this.id)');
p.innerHTML="Eliminar Propiedad";

box_input_delete.appendChild(i);
box_input_delete.appendChild(p);
row.appendChild(box_input_delete);
//input delete

div_collapse.appendChild(row);
box_properties.appendChild(div_collapse);
//box collapse

}

window.delete_property = function delete_property(id){
$('#box_properties_'+id).find('#header_'+id).remove();
$('#box_properties_'+id).find('#collapse_property_'+id).remove();
}
